export class Config {
  constructor(
    public BaseUrlApi: string = "",
    public BaseUrlAuth: string = "",
    public PLApplicationURL: string = "",
    public Dev_URL: string = "",
    public Canvas_AdminAccountId: string = "",
    public UserIdleTime: number = 3600000,
    public UserIdleTimePrompt: number = 30000
  ) {}
}
